<template>
  <section id="businessInfo">
    <div class="container">
      <div class="header">
        <h5>Business</h5>
        <CancelButton></CancelButton>
      </div>
      <form action="#" class="infoForm" autocomplete="off">
        <h5>Tell us a bit about your business</h5>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label for="tradingName">
                Full Trading Name
                <span>*</span>
              </label>
              <input
                v-validate="'required'"
                v-model="tradingName"
                id="tradingName"
                class="input"
                name="Trading Name"
                type="text"
                required
                v-on:keyup.enter="focusOut($event)"
              />
              <!-- <span>{{ errors.first('Trading Name') }}</span> -->
            </div>
          </div>
          <div class="column is-one-third">
            <div class="control">
              <label for="tradingAs"
                >Known or Preferred Name (if Applicable)</label
              >
              <input
                v-model="tradingAs"
                id="tradingAs"
                class="input"
                type="text"
                v-on:keyup.enter="focusOut($event)"
              />
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third typeOfBussiness">
            <label for="businessType">
              Type of Business
              <span>*</span>
            </label>
            <div class="select">
              <select
                name="Bussiness Type"
                v-validate="'required'"
                v-model="businessType"
                id="businessType"
                required
                v-on:keyup.enter="focusOut($event)"
              >
                <option value disabled>Select Option</option>
                <option value="Closed Corporation">
                  Closed Corporation (CC)
                </option>
                <option value="Sole Proprioter">Sole Proprietor</option>
                <option value="PTY LTD">PTY LTD</option>
                <option value="Partnership">Partnership</option>
                <option value="Trust">Trust</option>
              </select>
            </div>
          </div>
          <div class="column is-one-third typeOfBussiness">
            <label for="businessNatureType">
              Nature of Business
              <span>*</span>
            </label>
            <div class="select">
              <select
                name="Bussiness Nature Type"
                v-validate="'required'"
                v-model="businessNatureType"
                id="businessNatureType"
                required
                v-on:keyup.enter="focusOut($event)"
              >
                <option value disabled>Select Option</option>
                <option value="Engineering & Manufacturing">
                  Engineering and Manufacturing
                </option>
                <option value="Building & Construction">
                  Building and Construction
                </option>
                <option value="Painting Contractor">Painting Contractor</option>
                <option value="Shopfitting">Shopfitting</option>
                <option value="Hosp,School,Religious,Hotel">
                  Hospital | School | Religious | Hotel
                </option>
                <option value="Body Corps & Prop Management">
                  Body Corps and Property Management
                </option>
                <option value="Wholesaler & Retailer">
                  Wholesaler and Retailer
                </option>
                <option value="Exporter">Exporter</option>
                <option value="Interior Decorator">Interior Decorator</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>
          <div
            v-if="this.businessNatureType === 'Other'"
            class="column is-one-third"
          >
            <div class="control typeOfBussiness">
              <label for="compRegNum">
                Other Nature of Business
                <span>*</span>
              </label>
              <input
                v-model="businessNatureOtherType"
                v-validate="'required'"
                id="compRegNum"
                class="input"
                type="text"
                required
                v-on:keyup.enter="focusOut($event)"
              />
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label for="vatRegNum">Vat Registration Number</label>
              <input
                v-model="vatRegNum"
                id="vatRegNum"
                class="input"
                type="number"
                required
                v-on:keyup.enter="focusOut($event)"
              />
              <small>Leave blank if not VAT registered</small>
            </div>
          </div>
          <div class="column is-one-third">
          <div class="control">
            <label for="compRegNum">
              Company registration or ID number
              <span>*</span>

            </label>
                          <span
              ><svg fill="#000000"        width="10px"
                height="10px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
    <path d="M960 0c530.193 0 960 429.807 960 960s-429.807 960-960 960S0 1490.193 0 960 429.807 0 960 0Zm0 101.053c-474.384 0-858.947 384.563-858.947 858.947S485.616 1818.947 960 1818.947 1818.947 1434.384 1818.947 960 1434.384 101.053 960 101.053Zm-42.074 626.795c-85.075 39.632-157.432 107.975-229.844 207.898-10.327 14.249-10.744 22.907-.135 30.565 7.458 5.384 11.792 3.662 22.656-7.928 1.453-1.562 1.453-1.562 2.94-3.174 9.391-10.17 16.956-18.8 33.115-37.565 53.392-62.005 79.472-87.526 120.003-110.867 35.075-20.198 65.9 9.485 60.03 47.471-1.647 10.664-4.483 18.534-11.791 35.432-2.907 6.722-4.133 9.646-5.496 13.23-13.173 34.63-24.269 63.518-47.519 123.85l-1.112 2.886c-7.03 18.242-7.03 18.242-14.053 36.48-30.45 79.138-48.927 127.666-67.991 178.988l-1.118 3.008a10180.575 10180.575 0 0 0-10.189 27.469c-21.844 59.238-34.337 97.729-43.838 138.668-1.484 6.37-1.484 6.37-2.988 12.845-5.353 23.158-8.218 38.081-9.82 53.42-2.77 26.522-.543 48.24 7.792 66.493 9.432 20.655 29.697 35.43 52.819 38.786 38.518 5.592 75.683 5.194 107.515-2.048 17.914-4.073 35.638-9.405 53.03-15.942 50.352-18.932 98.861-48.472 145.846-87.52 41.11-34.26 80.008-76 120.788-127.872 3.555-4.492 3.555-4.492 7.098-8.976 12.318-15.707 18.352-25.908 20.605-36.683 2.45-11.698-7.439-23.554-15.343-19.587-3.907 1.96-7.993 6.018-14.22 13.872-4.454 5.715-6.875 8.77-9.298 11.514-9.671 10.95-19.883 22.157-30.947 33.998-18.241 19.513-36.775 38.608-63.656 65.789-13.69 13.844-30.908 25.947-49.42 35.046-29.63 14.559-56.358-3.792-53.148-36.635 2.118-21.681 7.37-44.096 15.224-65.767 17.156-47.367 31.183-85.659 62.216-170.048 13.459-36.6 19.27-52.41 26.528-72.201 21.518-58.652 38.696-105.868 55.04-151.425 20.19-56.275 31.596-98.224 36.877-141.543 3.987-32.673-5.103-63.922-25.834-85.405-22.986-23.816-55.68-34.787-96.399-34.305-45.053.535-97.607 15.256-145.963 37.783Zm308.381-388.422c-80.963-31.5-178.114 22.616-194.382 108.33-11.795 62.124 11.412 115.76 58.78 138.225 93.898 44.531 206.587-26.823 206.592-130.826.005-57.855-24.705-97.718-70.99-115.729Z" fill-rule="evenodd"/>
</svg></span>
            <input
              v-model="compRegNum"
              v-validate="'required'"
              id="compRegNum"
              class="input"
              type="number"
              required
              v-on:keyup.enter="focusOut($event)"
            />                <small>Required for verification purposes and use of credit balance.</small>
            </div>
          </div>
          <div v-if="businessType == 'Trust'" class="column is-one-third">
            <div class="control">
              <label for="trustITnum"> Trust IT Number </label>
              <input
                v-model="trustITnum"
                id="trustITnum"
                class="input"
                type="text"
                required
                v-on:keyup.enter="focusOut($event)"
              />
 
            </div>
          </div>
        </div>
      </form>
      <!-- <div class="note column is-two-thirds b2bNotes">
      <p><b>Please Note:</b><br>
      As a Business to Business customer you will need to send us verification that you are a trade customer to activate your account. You'll get details on how to do this, and a list of accepted documents in your confirmation email. </p>
      </div> -->
      <div class="actions">
        <button @click="back()" class="button">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button @click="toBusinessNote()" class="button is-danger">
          Continue
        </button>
      </div>
    </div>
  </section>
</template>


<script>
import CancelButton from "../../components/actions/CancelButton";
import alertify from "alertifyjs";

export default {
  name: "businessInfo",
  data() {
    return {
      tradingName: null,
      tradingAs: null,
      businessType: null,
      businessNatureType: null,
      businessNatureOtherType: null,
      compRegNum: null,
      trustITnum: null,
      vatRegNum: null,
    };
  },
  components: {
    CancelButton,
  },
  methods: {
    toBusinessNote() {
      this.$validator.validate().then((result) => {
        if (!result) {
          this.loading = false;
          alertify.error("Please check all fields are filled in correctly.");
        } else {
          this.$gtag.event("type_of_business", {
            event_category: "engagement",
            event_label: this.businessType,
            value: "",
          });
          this.$gtag.event("nature_of_business", {
            event_category: "engagement",
            event_label: this.businessNatureType,
            value: "",
          });
          this.$store.commit("STORE_BUSINESS_INFO", {
            tradingName: this.tradingName,
            tradingAs: this.tradingAs,
            businessType: this.businessType,
            businessNatureType: this.businessNatureType,
            businessNatureOtherType: this.businessNatureOtherType,
            compRegNum: this.compRegNum,
            trustITnum: this.trustITnum,
            vatRegNum: this.vatRegNum,
          });
          this.$router.push("/businessContactInfo");
        }
      });
    },
    back() {
      document.body.classList.add("transitionBack");

      this.$router.go(-1);

      setTimeout(() => {
        document.body.classList.remove("transitionBack");
      }, 1000);
    },
  },
  mounted() {
    if (this.$store.state.isBusiness) {
      document.body.classList.add("isBusiness");
    }
    this.tradingName = this.$store.state.business.info.tradingName;
    this.tradingAs = this.$store.state.business.info.tradingAs;
    this.businessType = this.$store.state.business.info.businessType;
    this.businessNatureType =
      this.$store.state.business.info.businessNatureType;
    this.businessNatureOtherType =
      this.$store.state.business.info.businessNatureOtherType;
    this.compRegNum = this.$store.state.business.info.compRegNum;
    this.trustITnum = this.$store.state.business.info.trustITnum;
    this.vatRegNum = this.$store.state.business.info.vatRegNum;
  },
};
</script>
